export default __webpack_public_path__ + "static/media/refresh2.9a9c034c.svg";